/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import IconYoutube from "assets/icons/IconYoutube";
import IconFacebook from "assets/icons/IconFacebook";
import IconLinkedin from "assets/icons/IconLinkedin";
import IconInstagram from "assets/icons/IconInstagram";
import { useTheme } from "styled-components";
import useGetCountry from "hooks/useGetCountry";
import { isShobiddak } from "helpers/osHelpers";
import IconTwitter from "assets/icons/IconTwitter";

const FollowUs = () => {
  const { translations } = useTheme();
  const currentCountry = useGetCountry();
  if (!currentCountry) return <p>"Error FollowUs"</p>;
  return (
    <div className="font-14">
      {translations.footer.followUs}
      <br />
      <a
        href={
          isShobiddak()
            ? "https://www.facebook.com/Shobiddak2008"
            : currentCountry.facebook_url
        }
        aria-label="OpenSooq facebook"
        className="inline vMiddle"
        target="_blank"
      >
        <IconFacebook width="26" height="26" />
      </a>{" "}
      <a
        href={currentCountry.twitter_url}
        aria-label="OpenSooq twitter"
        className="inline vMiddle"
        target="_blank"
      >
        <IconTwitter width="23" height="23" />
      </a>{" "}
      <a
        href={
          isShobiddak()
            ? "https://www.instagram.com/shobiddak.ps"
            : currentCountry.instagram_url
        }
        aria-label="OpenSooq instagram"
        className="inline vMiddle"
        target="_blank"
      >
        <IconInstagram width="25" height="25" />
      </a>{" "}
      <a
        href={"https://www.youtube.com/opensooq"}
        aria-label="OpenSooq youtube"
        className="inline vMiddle"
        target="_blank"
      >
        <IconYoutube width="25" height="25" />
      </a>{" "}
      <a
        href="https://www.linkedin.com/company/opensooq/"
        aria-label="OpenSooq linkedin"
        className="inline vMiddle"
        target="_blank"
      >
        <IconLinkedin width="25" height="25" />
      </a>
    </div>
  );
};

export default FollowUs;
